<template>
  <div id="login">
    <div class="loginBox">
      <div class="loginTop">
        <div class="wrap">
          <div class="left">
            <el-image
              style="width: 50px; height: 50px"
              :src="srcUrl"
            ></el-image>
            <span>
              网关配置管理平台</span>
          </div>
          <div>
            <el-button
              class="btn"
              type="primary"
            >控制台</el-button>
          </div>
        </div>
      </div>
      <div class="contentBox">
        <div class="wrap">
          <div class="queer">
            <h1>网关配置管理平台</h1>
            <p>助力企业数字化转型，物联网化设备管理</p>
            <p>提供综合监控服务，远程配置服务，采集应用服务</p>
            <div class="line">
              <el-button class="btn" @click="login">登录使用</el-button>
              <el-button class="btn2">用户注册</el-button>
            </div>
          </div>
          <div class="right">
            <el-image
              style="width: 500px; height: 500px"
              :src="srcUrl2"
            ></el-image>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="contentLayer">
        <div class="wrap1">
          <div class="lines"></div>
          <div class="Ti">
            <span class="des">智慧能源网关</span>
            <span class="circle"></span>
            <span class="des">企业数字化转型</span>
          </div>
          <div class="depict"> 通过能源网关设备物联网可以建立能源监控系统，实现从能源数据采集--过程监控--能耗分析--能耗优化管理等全过程的智能化管理，从而是能源生产和管理、设备监控和维护有机结合起来，可以有效利用数据处理和分析技术，进行远程的、无人的设备管理。</div>
          <div class="ul">
            <div class="list">
              <div class="round">
                <img
                  src="../assets/yuan.png"
                  class="iconImg"
                  alt=""
                >
              </div>
              <div class="divImg">
                <img
                  src="../assets/icon/phone.png"
                  class="Img"
                  alt=""
                >
              </div>
              <div class="typeName">自动采集存储</div>
              <div class="des">根据协议配置，实现自动化采集解析设备数据，按时序存储，断点续传。保障数据有效连续</div>
            </div>
            <div class="list">
              <div class="round">
                <img
                  src="../assets/yuan.png"
                  class="iconImg"
                  alt=""
                >
              </div>
              <div class="divImg">
                <img
                  src="../assets/icon/sicon.png"
                  class="Img"
                  alt=""
                >
              </div>
              <div class="typeName">安全稳定，高性能</div>
              <div class="des">多级应用守护，传输数据加密，毫秒级数据采集转换；保障数据安全，稳定及高效传输</div>
            </div>
            <div class="list">
              <div class="round">
                <img
                  src="../assets/yuan.png"
                  class="iconImg"
                  alt=""
                >
              </div>
              <div class="divImg">
                <img
                  src="../assets/icon/yao.png"
                  class="Img"
                  alt=""
                >
              </div>
              <div class="typeName">远程调控</div>
              <div class="des">智能网关支持本地或远程配置升级，提升项目甲方、集成商、运营方等各方的管理效率</div>
            </div>
            <div class="list">
              <div class="round">
                <img
                  src="../assets/yuan.png"
                  class="iconImg"
                  alt=""
                >
              </div>
              <div class="divImg">
                <img
                  src="../assets/icon/wifi.png"
                  class="Img"
                  alt=""
                >
              </div>
              <div class="typeName">多协议转换</div>
              <div class="des">
                内置多种通用协议，满足各种设备的数据互联传输，国际标准协议包括：MQTT、OPC、Modbus、IEC-104、CJT188、DLT645、HTTP等
              </div>
            </div>
            <div class="list">
              <div class="round">
                <img
                  src="../assets/yuan.png"
                  class="iconImg"
                  alt=""
                >
              </div>
              <div class="divImg">
                <img
                  src="../assets/icon/comp.png"
                  class="Img"
                  alt=""
                >
              </div>
              <div class="typeName">边缘计算</div>
              <div class="des">有丰富的规则算法，实现数据分析，设备预警，联动控制等功能</div>
            </div>

          </div>
        </div>
      </div>
      <!-- 脚部 -->
      <div class="footer">
        <div class="wrap">
          <div class="lf">
            <p>Copyright © www.gz-hoko.com, All Rights Reserved. </p>
            <p>工业和信息化部备案管理系统网站 | 粤ICP备14059767号 | 粤公网安备 44010302000948号</p>
          </div>
          <div class="rg">
            <div class="list">
              <div class="box">
                <i class="iconfont icon-weixin"></i>
              </div>
              <div class="title">
                <p>微信公众号</p>
                <p>搜索关注：HOKO</p>
              </div>
            </div>
            <div class="list">
              <div class="box">
                <i class="iconfont icon-QQ"></i>
              </div>
              <div class="title">
                <p>QQ交流群</p>
                <p>查看交流群信息</p>
              </div>
            </div>
            <div class="list">
              <div class="box">
                <i class="iconfont icon-youxiang"></i>
              </div>
              <div class="title">
                <p>联系邮箱</p>
                <p>service@gz-hoko.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      srcUrl: require("@/assets/top.png"),
      srcUrl2: require("@/assets/bg-index.png"),
    };
  },
  methods: {
    login(){
        this.$router.push("/adminLogin");
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.loginBox {
  width: 100%;
  height: 100vh;
  overflow: auto;
  .loginTop {
    width: 100%;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.78);
    height: 70px;
    line-height: 70px;
    z-index: 10;
  }
  .wrap {
    width: 1100px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    span {
      font-size: 16px;
      padding-left: 20px;
      color: #ffffff;
    }
    .btn {
      width: 120px;
      border-radius: 45px;
      border: none;
      background: -webkit-linear-gradient(
        180deg,
        rgba(0, 110, 255, 1) 2%,
        rgba(111, 80, 236, 1) 100%
      );
      background: -moz-linear-gradient(
        270deg,
        rgba(0, 110, 255, 1) 2%,
        rgba(111, 80, 236, 1) 100%
      );
      background: linear-gradient(
        270deg,
        rgba(0, 110, 255, 1) 2%,
        rgba(111, 80, 236, 1) 100%
      );
    }
  }

  .contentBox {
    width: 100%;
    height: 500px;
    background-color: rgba(0, 9, 77, 1);
    color: #ffffff;
    .queer {
      h1 {
        font-size: 40px;
      }
      p {
        font-size: 24px;
      }
      .line {
        padding-top: 30px;
        color: #ffffff;
        .btn {
          color: #ffffff;
        }
        .btn2 {
          background: none;
          width: 120px;
          border-radius: 45px;
          color: #ffffff;
          margin-left: 80px;
        }
      }
    }
  }
  .contentLayer {
    width: 100%;
    // height: 200px;
    background: #f5f5f5;
    padding: 45px 0;
    .wrap1 {
      width: 1100px;
      margin: 0 auto;
    }
    .lines {
      width: 100px;
      height: 5px;
      background: #005ce6;
    }
    .Ti {
      padding-top: 25px;
      span {
        color: #333333;
      }
      .circle {
        display: inline-block;
        margin: 0 10px;
        width: 20px;
        height: 20px;
        background: #333333;
        border-radius: 50%;
      }
      .des {
        font-size: 24px;
        color: #333333;
      }
    }
    .depict {
      padding: 15px 0;
      font-size: 18px;
      color: #666666;
      text-indent: 2em;
    }
    .ul {
      display: flex;
      justify-content: space-between;
      .list {
        position: relative;
        left: 0px;
        top: 0px;
        width: 208px;
        height: 298px;
        background-color: #ffffff;
        border: none;
        border-radius: 5px;
        box-shadow: 1px 0px 5px rgba(0, 0, 0, 0.3);
        padding: 10px;
        margin: 10px;
        &:hover {
          top: -5px;
        }
        .round {
          width: 100px;
          height: 100px;
          background: #ffffff;
          border-radius: 50%;
          box-shadow: 1px 0px 5px rgba(0, 0, 0, 0.3);
          margin: 15px auto;
          .iconImg {
            width: 30px;
            height: 30px;
            padding-top: 20px;
            padding-left: 20px;
          }
        }
        .divImg {
          position: absolute;
          top: 21%;
          left: 50%;
          transform: translate(-50%, -28%);
          .Img {
            // width: 50px;
            // height: 50px;
            margin: 0 auto;
          }
        }
        .typeName {
          font-size: 18px;
          color: #333333;
          padding: 15px 0;
          text-align: center;
        }
        .des {
          line-height: 20px;
          font-size: 14px;
          color: #666666;
          padding: 10px 0;
          font-size: 14px;
          text-align: left;
        }
      }
    }
  }

  .footer {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100px;
    background: #333333;
    font-size: 12px;
    color: #999999;
    .lf {
      padding-right: 30px;
    }
    .rg {
      display: flex;

      .list {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 30px;
      }
      .box {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 35px;
        height: 35px;
        background-color: rgba(255, 255, 255, 0);
        box-sizing: border-box;
        border: 1px solid #cccccc;
        border-radius: 50%;
        .iconfont {
          font-size: 24px;
        }
      }
      .title {
        padding-left: 10px;
        font-size: 12px;
        color: #999999;
      }
    }
  }
}
</style>

